import { render, staticRenderFns } from "./RCard.vue?vue&type=template&id=5909fd80&scoped=true&"
var script = {}
import style0 from "./RCard.vue?vue&type=style&index=0&id=5909fd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909fd80",
  null
  
)

export default component.exports